<template>
  <div>
    <div  style="width:80%; margin: 60px auto;">
      <div style="color: #333;font-size: 22px;margin-bottom: 30px">{{ this.$t('title.Interface_docking_instructions') }}</div>
      <p>
        {{ this.$t('title.Interface_document_address') }}
        <a href="http://api-manager.thinkium.org/">http://api-manager.thinkium.org/</a>
      </p>
      <p>
         {{ this.$t('title.Interface_docking_instructions1') }}
      </p>
      <p>
        {{ this.$t('title.Interface_docking_instructions2') }}
      </p>
      <p>
        {{ this.$t('title.Interface_docking_instructions3') }}
      </p>
      <p>
        {{ this.$t('title.Interface_docking_instructions4') }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>

</style>